/* src/app/admin/post/post.component.scss */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider {
  background-color: #2196F3;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.doc-cell {
  min-width: 150px;
  max-width: 250px;
}
.doc-cell:hover {
  background-color: #f4f4f4;
  cursor: pointer;
}
.doc-cell:hover::after {
  content: "x";
  color: black;
  font-weight: 400;
  font-family: Arial, sans-serif;
  float: right;
  margin-right: 10px;
}
.doc-new-cell {
  min-width: 150px;
  max-width: 250px;
}
.doc-list {
  border: 1px solid #ebebeb;
  padding: 8px;
  border-radius: 3px;
}
/*# sourceMappingURL=post.component-7RHTZ2XP.css.map */
